import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Booking } from './pages/Booking';
import { Stub } from './pages/Stub';
import { ServicesList } from './pages/ServicesList';
import { ServiceDetail } from './pages/ServiceDetail';
import { Blog } from './pages/Blog';
import { Contact } from './pages/Contact';
import { PatientInformation } from './pages/PatientInformation';
import { FAQ } from './pages/FAQ';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { About } from './pages/About';
import { BlogPost } from './pages/BlogPost';
import { CSRInitiatives } from './pages/CSRInitiatives';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2whxcnx635uha">
      <Layout data-id="element-1" data-mp="28u5y0mx2p5cu">
        <Routes data-id="element-2" data-mp="28tw3qn4zwc1c">
          <Route path="/" element={<Home data-id="element-4" data-mp="28sl3gxardmez" />} data-id="element-3" data-mp="28te3lff7pdo5" />
          <Route path="/book" element={<Booking data-id="element-6" data-mp="23vunsb2v8su3" />} data-id="element-5" data-mp="28s2zfehuu3wi" />

          {/* Fully built pages */}
          <Route path="/patient-information" element={<PatientInformation data-id="element-8" data-mp="3ikr002qv3a7b" />} data-id="element-7" data-mp="23t8gmcjw0fce" />
          <Route path="/blog" element={<Blog data-id="element-10" data-mp="3ii4qvyobommz" />} data-id="element-9" data-mp="3ijfunyhrpue3" />
          <Route path="/blog/:id" element={<BlogPost data-id="element-12" data-mp="3mk85uxa7a9d0" />} data-id="element-11" data-mp="3mlatmwc87vop" />
          <Route path="/contact" element={<Contact data-id="element-14" data-mp="3rcj5s04xxv5k" />} data-id="element-13" data-mp="3mjpyp5m02aqb" />
          <Route path="/services" element={<ServicesList data-id="element-16" data-mp="3rd1bdndhtlq5" />} data-id="element-15" data-mp="3rbzngibdp4r0" />
          <Route path="/services/:slug" element={<ServiceDetail data-id="element-18" data-mp="4wvvprmowg9" />} data-id="element-17" data-mp="5yjsutqtdfe" />
          <Route path="/faq" element={<FAQ data-id="element-20" data-mp="2zl39tfhhuw2o" />} data-id="element-19" data-mp="56mnfkhz7n0" />
          <Route path="/privacy" element={<Privacy data-id="element-22" data-mp="2zmeo498kfm81" />} data-id="element-21" data-mp="2zlle8zeb8glo" />
          <Route path="/terms" element={<Terms data-id="element-24" data-mp="33mf2xuzktzfm" />} data-id="element-23" data-mp="2zn69yscd25l4" />
          <Route path="/about" element={<About data-id="element-26" data-mp="33n6y54p9hv5d" />} data-id="element-25" data-mp="33lwzadal4ixo" />
          <Route path="/csr-initiatives" element={<CSRInitiatives data-id="element-28" data-mp="38l8eviz7tido" />} data-id="element-27" data-mp="33orla998ybt7" />

          {/* Coming-soon pages */}
          <Route path="/doctors" element={<Stub data-id="element-30" data-mp="3dl4mrtb19tyi" />} data-id="element-29" data-mp="38o4d78ez692n" />
          <Route path="/facilities" element={<Stub data-id="element-32" data-mp="3diry6xarslch" />} data-id="element-31" data-mp="3dlnukh6yz1yt" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}